import { useEffect } from 'react';

const APP_NAME = 'e-Invoicing';

/**
 * Sets the document title for the current page.
 * Ensures each page has a unique, descriptive title per WCAG 2.4.2.
 * @param pageTitle - The title describing the current page's topic or purpose.
 */
export function usePageTitle(pageTitle: string): void {
    useEffect(() => {
        document.title = `${pageTitle} - ${APP_NAME}`;
        return () => {
            document.title = APP_NAME;
        };
    }, [pageTitle]);
}
